<template>
    <form @submit.prevent="onSubmit()" @keydown="form.$errors.clear($event.target.name);">
        <b-alert :show="anonymizedUserForm" variant="danger">
            {{ $t('[[[UWAGA! Konto tego użytkownika zostało zanonimizowane w dniu ]]]') }}{{ form.anonymisationDateUtc | date }}{{ '. ' + $t('[[[Nie należy wprowadzać na tym koncie żadnych zmian.]]]') }}
        </b-alert>
        <div class="card card-form">
            <div class="row no-gutters">
                <div class="col-xl-9 p-3">
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group :label="$t('[[[Nazwa użytkownika]]]')" :feedback="form.$errors.first('userName')" :state="form.$errors.state('userName')" v-required>
                                <b-form-input v-model="form.userName" type="text" name="userName" :disabled="anonymizedUserForm" v-focus></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[Imię]]]')" :feedback="form.$errors.first('givenName')" :state="form.$errors.state('givenName')">
                                <b-form-input v-model="form.givenName" type="text" name="givenName" :disabled="anonymizedUserForm"></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[Nazwisko]]]')" :feedback="form.$errors.first('surname')" :state="form.$errors.state('surname')">
                                <b-form-input v-model="form.surname" type="text" name="surname" :disabled="anonymizedUserForm"></b-form-input>
                            </b-form-group>
                            <b-form-group :label="$t('[[[E-mail]]]')" :feedback="form.$errors.first('email')" :state="form.$errors.state('email')" v-required>
                                <b-form-input v-model="form.email" type="email" name="email" :disabled="anonymizedUserForm"></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-checkbox v-model="form.emailConfirmed" :disabled="anonymizedUserForm">{{ $t('[[[Adres e-mail potwierdzony]]]') }}</b-form-checkbox>
                            </b-form-group>
                            <b-form-group>
                                <b-form-checkbox v-model="form.isActive" :disabled="anonymizedUserForm">{{ $t('[[[Konto aktywne]]]') }}</b-form-checkbox>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <div class="card bg-light mb-3">
                                <div class="card-body">
                                    <b-form-group :label="$t('[[[Hasło]]]')" :feedback="form.$errors.first('newPassword')" :state="form.$errors.state('newPassword')">
                                        <b-form-input v-model="form.newPassword" type="password" name="newPassword" autocomplete="off" :disabled="anonymizedUserForm"></b-form-input>
                                    </b-form-group>
                                    <b-form-group :label="$t('[[[Powtórz hasło]]]')" :feedback="form.$errors.first('repeatPassword')" :state="form.$errors.state('repeatPassword')">
                                        <b-form-input v-model="form.repeatPassword" type="password" name="repeatPassword" autocomplete="off" :disabled="anonymizedUserForm"></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                            <b-form-group :label="$t('[[[Role użytkownika]]]')">
                                <b-form-checkbox-group name="roles" v-model="form.roles" :options="options.roles" value-field="id" text-field="roleName" :disabled="anonymizedUserForm" stacked></b-form-checkbox-group>
                                <b-alert :show="options.roles.length == 0">{{ $t('[[[Nie zdefiniowano żadnych ról.]]]') }}</b-alert>
                            </b-form-group>
                            <hr>
                            <b-form-group>
                                <b-form-checkbox v-model="form.isAdmin" :disabled="anonymizedUserForm">{{ $t('[[[Użytkownik posiada pełne uprawnienia]]]') }}</b-form-checkbox>
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="sidebar col-xl-3 p-3">
                    <div class="row">
                        <div class="col-xl-12 col-sm-6">
                            <b-form-group :label="$t('[[[Zdjęcie użytkownika]]]')" :feedback="form.$errors.first('facePicture')" :state="form.$errors.state('facePicture')">
                                <fileupload v-if="!anonymizedUserForm" v-model="form.facePicture" :maxFiles="1" :accept="['image/jpeg', 'image/png']"></fileupload>
                                <b-img v-if="anonymizedUserForm && form.facePicture" :src="form.facePicture | image('avatar')" width="150" height="150" blank-color="#777" />
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Przyciski -->
            <div class="card-footer">
                <responsive>
                    <button type="submit" class="btn btn-primary" :disabled="form.disabled() || !form.meta.canEdit">
                        <i class="fas fa-check"></i> {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <button type="button" class="btn btn-secondary" @click="onSubmit('core-users')" :disabled="form.disabled() || !form.meta.canEdit">
                        <i class="far fa-check-circle"></i> {{ $t('[[[Zapisz i wróć]]]') }}
                    </button>
                    <router-link class="btn btn-light" :to="{name:'core-users'}">
                        <i class="far fa-arrow-alt-circle-left"></i> {{ $t('[[[Powrót]]]') }}
                    </router-link>
                </responsive>
            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/helpers/Form';
import AuthService from '@/services/core/AuthService';
import UsersService from '@/services/core/UsersService';
import RolesService from '@/services/core/RolesService';
import StorageService from '@/services/core/StorageService';

export default
{
    data: function()
    {
        return {
            options: {
                roles: []
            },
            form: Form.create({
                id: 0,
                userName: '',
                email: '',
                emailConfirmed: false,
                givenName: '',
                surname: '',
                facePicture: null,
                newPassword: '',
                repeatPassword: '',
                roles: [],
                isAdmin: false,
                isActive: false,
                meta: {
                    canEdit: true
                }
            }),
            anonymizedUserForm: false
        };
    },

    created: function()
    {
        this.initForm();

        if (this.id)
        {
            this.loadData(this.id);
        }
    },

    computed: {
        id()
        {
            return this.$route.params.id;
        }
    },

    methods: {
        async initForm()
        {
            this.form.disable();

            try
            {
                let response = await RolesService.getAllRoles();
                this.options.roles = response.data;
                this.form.enable();
            }
            catch (ex)
            {
                this.form.$errors.push('roles', this.$t('[[[Nie udało się pobrać listy ról]]]'));
                this.$log.debug(ex);
            }
        },

        async loadData(id)
        {
            try
            {
                let response = await UsersService.fetch(id);

                this.form.withData(response.data);

                if (response.data.anonymisationDateUtc)
                {
                    this.anonymizedUserForm = true;
                    this.form.disable();
                }
            }
            catch (ex)
            {
                this.form.disable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        async onSubmit(route = 'core-users-edit')
        {
            try
            {
                this.form.disable();

                if (this.form.facePicture && this.form.facePicture.upload)
                {
                    this.form.facePicture = await StorageService.upload(this.form.facePicture);
                }

                if (!this.id)
                {
                    let result = await UsersService.create(this.form.data());
                    this.$alert.success(this.$t('[[[Użytkownik został dodany.]]]'));
                    this.form.withData(result.data);
                }
                else
                {
                    await UsersService.update(this.id, this.form.data());
                    this.$alert.success(this.$t('[[[Użytkownik został zaktualizowany.]]]'));

                    if (this.id === this.$auth.user().id)
                    {
                        await AuthService.fetchUser();
                    }
                }

                this.$router.push({ name: route, params: { id: this.form.id } });
                this.form.enable();
            }
            catch (ex)
            {
                this.form.enable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.form.$errors.record(ex.data.errors);

                this.$log.debug(ex);
            }
        }
    }
};
</script>
